import { render } from "./loadMore.vue?vue&type=template&id=ed9295f4"
import script from "./loadMore.vue?vue&type=script&lang=js"
export * from "./loadMore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__